import React, { Component } from "react";
import { connect } from "react-redux";
import { Table } from '@mawesi-sas/mws_react_component_table';
import FontAwesome from "react-fontawesome";
import Input from '@mawesi-sas/mws_react_component_input';

import Box from "../Layout/components/Box";
import ButtonStrip from "../Layout/components/ButtonStrip";
import BoxButton from "../Layout/components/BoxButton";

import { getDataFromServer, reiniciarEstado } from "./actions";
import history from "../../utils/history";

const WAIT_INTERVAL = 500;
const ENTER_KEY = 13;

class Reporte1 extends Component {
  constructor(props) {
    super(props);
    this.state = { filter: false };
  }

  componentWillMount() {
    this.props.reiniciarEstado();
    this.props.getDataFromServer();
  }

  handleOnChange = (value) => {
    clearTimeout(this.timer);
    this.setState({ value });
    this.timer = setTimeout(this.triggerChange, WAIT_INTERVAL);
  };

  handleOnKeyDown = (key) => {
    if (key.keyCode === ENTER_KEY) {
      clearTimeout(this.timer);
      this.triggerChange();
    }
  };

  triggerChange = () => {
    this.props.getDataFromServer();
  };

  render() {
    if (!this.props.elementos) return null;

    const buttons = [];
    buttons.push(
      <BoxButton
        key={`action[0][1]`}
        name="filter"
        onClick={(e) => this.setState({ filter: !this.state.filter })}
        title="Filtrar"
      />
    );
    if (this.props.elementos.filter((x) => x === "Fctqlxpe").count()) {
      buttons.push(
        <BoxButton
          key={`action[0][2]`}
          name="cloud-download"
          onClick={(e) => this.props.getDataFromServer(1, true)}
          title="Descargar reporte"
        />
      );
    }

    return (
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div className="row" style={{ height: "100%" }}>
          <div className="col-md-12" style={{ height: "100%" }}>
            <Box title="Compras por cafetería" stretch>
              <ButtonStrip actions={buttons} />
              {this.state.filter && (
                <div className="buttonstrip">
                  <Input
                    type="text"
                    reducer="reporte2"
                    path="filter"
                    afterChange={this.handleOnChange}
                    onKeyDown={this.handleOnKeyDown}
                    placeholder="Filtrar..."
                  />
                </div>
              )}
              <div>
                <div className="row" style={{ marginTop: "10px" }}>
                  <div className="col-md-3">
                    <div className="form-group" style={{ marginBottom: "0" }}>
                      <Input
                        type="select"
                        reducer="reporte2"
                        path="cafeteria"
                        placeholder="Seleccione una cafetería"
                        options={this.props.cafeterias}
                        afterChange={this.triggerChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="box-content"
                style={{
                  flex: 1,
                  height: 0,
                }}
              >
                <Table
                  reducer="reporte2"
                  table="reporte2"
                  selectionMode="multiple"
                  take={100}
                  whenNoData={
                    <div
                      style={{
                        color: "#888",
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        border: "1px solid rgb(221, 221, 221)",
                        background: "rgb(243, 243, 243)",
                      }}
                    >
                      No se encontraron solicitudes que cumplan con los
                      criterios de busqueda
                    </div>
                  }
                  columns={[
                    {
                      ID: 0,
                      CAPTION: "Solicitud",
                      WIDTH: 90,
                      TYPE: "custom",
                      RENDER_ROW: (reg) => {
                        return (
                          <span
                            style={{
                              color: "#4f9fcf",
                              cursor: "pointer",
                            }}
                            onClick={(e) =>
                              history.push(
                                `${window.FOLDER}/solicitudes/${reg.get("id")}`
                              )
                            }
                          >
                            {reg.getIn("id".split("."))}
                          </span>
                        );
                      },
                    },
                    {
                      ID: 1,
                      CAPTION: "Motivo",
                      VALUE: "motivo",
                      TYPE: "text",
                    },
                    {
                      ID: 2,
                      CAPTION: "Fecha y hora",
                      VALUE: "fecha_hora",
                      TYPE: "date",
                    },
                    {
                      ID: 3,
                      CAPTION: "Solicitante",
                      VALUE: "solicitante.name",
                      TYPE: "text",
                    },
                    {
                      ID: 4,
                      CAPTION: "Fecha de creación",
                      VALUE: "created_at",
                      TYPE: "date",
                    },
                    {
                      ID: 5,
                      CAPTION: "Recursos",
                      WIDTH: 400,
                      TYPE: "custom",
                      RENDER_ROW: (reg) => {
                        return reg.get("distribuciones").map((x) => {
                          return (
                            <span
                              key={`span[0][${x.get("id")}]`}
                              title={x.getIn("cenco.nombre".split("."))}
                              style={{
                                fontSize: "1em",
                              }}
                              className={`label label-light-grey`}
                            >
                              {x.getIn("cenco.codigo".split("."))}
                              &nbsp;|&nbsp;
                              {x.get("porcentaje")}%
                            </span>
                          );
                        });
                      },
                    },
                    {
                      ID: 6,
                      CAPTION: "Cafetería",
                      VALUE: "nombre_cafeteria",
                      TYPE: "text",
                    },
                    {
                      ID: 7,
                      CAPTION: "Valor total",
                      VALUE: "valor_total",
                      TYPE: "number",
                      FORMAT: "$0,0.00",
                    },
                    {
                      ID: 8,
                      CAPTION: "Estado",
                      WIDTH: 80,
                      TYPE: "custom",
                      RENDER_ROW: (reg) => {
                        const estado = reg.get("estado").toUpperCase();
                        let color = "default";
                        switch (estado) {
                          case "CREADA":
                            color = "info";
                            break;
                          case "APROBADA":
                            color = "warning";
                            break;
                          case "CANCELADA":
                            color = "danger";
                            break;
                          case "COMPLETADA":
                            color = "success";
                            break;
                          case "FACTURADA":
                            color = "primary";
                            break;
                        }
                        return (
                          <span
                            style={{
                              fontSize: "1em",
                              display: "block",
                              margin: "2px 0",
                            }}
                            className={`label label-${color}`}
                          >
                            {reg.get("estado").toUpperCase()}
                          </span>
                        );
                      },
                    },
                  ]}
                  onCambiarPagina={(pg) => this.props.getDataFromServer(pg)}
                />
              </div>
            </Box>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    elementos: state.layout.get("elementos"),
    registros: state.reporte2.getIn("reporte2.records".split(".")),
    cafeterias: state.reporte2.get("cafeterias", []).toJS() || [],
  };
}

const mapDispatchToProps = {
  reiniciarEstado,
  getDataFromServer,
};

export default connect(mapStateToProps, mapDispatchToProps)(Reporte1);
